<template>
  <UIPopup
    v-model="modelValue"
    :closeable="false"
    :max-width="isDesktop ? '1130px' : isTablet ? '553px' : ''"
    :hide-buttons="true"
  >
    <template #body>
      <div class="absolute left-4 top-4 desktop:left-[55%] desktop:top-12">
        <UIButton
          id="back"
          variant="ghost"
          left-icon="arrow-big-filled-left"
          class="fill-gold-primary-20 !text-black-100"
          @click="useUIStore().showPopup(POPUPS.VERIFY_PHONE)"
        >
          {{ $t('auth.signup.email.contact.back') }}
        </UIButton>
      </div>
      <div class="flex flex-col justify-between pt-8 tablet:gap-9 desktop:flex-row desktop:gap-20 desktop:pt-0">
        <NuxtImg
          src="/images/signup/tablet-signup-4.webp"
          class="hidden max-h-[307px] rounded-xl object-cover tablet:block desktop:hidden"
        />
        <NuxtImg src="/images/signup/desktop-signup-4.webp" class="hidden object-cover desktop:block desktop:w-1/2" />
        <div class="mx-auto mt-8 flex w-full max-w-[325px] flex-col items-center justify-center gap-9 tablet:mt-0">
          <div class="flex w-full flex-col items-center gap-4">
            <h3 class="text-headline-3">{{ $t('onboarding.updatePhone.title') }}</h3>
            <p class="text-body-1 text-center">{{ $t('onboarding.updatePhone.subtitle') }}</p>
            <form ref="parentRef" class="flex w-full flex-col gap-4" @submit.prevent="onSubmit">
              <UIInputText
                name="firstName"
                :label="$t('onboarding.updatePhone.firstName')"
                :placeholder="$t('onboarding.updatePhone.firstName')"
              />
              <UIInputText
                name="lastName"
                :label="$t('onboarding.updatePhone.lastName')"
                :placeholder="$t('onboarding.updatePhone.lastName')"
              />
              <UIPhone
                name="phone"
                :label="$t('onboarding.updatePhone.phone')"
                :placeholder="$t('onboarding.updatePhone.phone')"
              />
              <UIButton id="update" :loading="isPending" type="submit" full-width>{{
                $t('onboarding.updatePhone.updateButton')
              }}</UIButton>
            </form>
          </div>
        </div>
      </div>
    </template>
  </UIPopup>
</template>

<script setup lang="ts">
import { useForm } from 'vee-validate'
import * as countryCodes from 'country-codes-list'
import { POPUPS } from '../dynamic/maps'
import { updatePhoneSchema } from '~/schemas/auth/profile'

const { isTablet, isDesktop } = useAppBreakpoints()

const modelValue = defineModel<boolean>()

const authStore = useAuthStore()

const currentCountry = countryCodes
  .all()
  .find((c) => c.countryCallingCode === authStore.user?.phone?.split(' ')?.[0].replace('+', ''))

const { handleSubmit } = useForm({
  validationSchema: updatePhoneSchema,
  initialValues: {
    firstName: authStore.user?.firstName,
    lastName: authStore.user?.lastName,
    phone: {
      number: Number(authStore.user?.phone?.split(' ')?.[1]),
      country: {
        name: currentCountry?.countryNameEn,
        phone_code: `+${currentCountry?.countryCallingCode}`,
        iso2: currentCountry?.countryCode,
        id: 0,
      },
    },
  },
})

const { catchErrors } = useErrorHandler()

const { mutateAsync: update, isPending } = useUpdateProfile()

const { refetch: refetchAgent } = useAgent()

const onSubmit = handleSubmit((values) => {
  update(values as any)
    .then(async () => {
      await refetchAgent()
      await nextTick()
      useUIStore().showPopup(POPUPS.VERIFY_PHONE, { force: true })
    })
    .catch(catchErrors)
})

const [parentRef] = useAutoAnimate()
</script>

<style scoped></style>
